import { eventTracker } from 'app/modules/Segment';
import {
  buildJusfyEventsContext,
  buildJusfyEventsProperties,
} from 'app/modules/Segment/buildJusfyEvent';
import {
  FeatureEnum,
  TContext,
  TProperties,
} from 'app/modules/Segment/types';
import { OabEditedField, OabEditedFields, OabSource } from './types';

const EVENTS = {
  ONBOARDING_OAB_STEP_VIEWED: 'onboarding_oab_step_viewed',
  ONBOARDING_OAB_PENDING_FOUND: 'onboarding_oab_pending_found',
  ONBOARDING_OAB_EDITED: 'onboarding_oab_edited',
  ONBOARDING_OAB_SUBMITTED: 'onboarding_oab_submitted',
  ONBOARDING_OAB_SKIPPED: 'onboarding_oab_skipped',
} as const;

const onboardingOabContext: TContext = buildJusfyEventsContext({
  component: 'onboarding-oab-flow',
});

function trackOnboardingOabEvent(
  event: string,
  relevantUserActivity: boolean,
  eventMeaning: string,
  additionalProperties?: Record<string, unknown>,
): void {
  const properties: TProperties = buildJusfyEventsProperties({
    event,
    feature: FeatureEnum.ONBOARDING,
    eventMeaning,
    relevantUserActivity,
    extraProperties: additionalProperties,
  });

  eventTracker.track({
    event,
    properties,
    context: onboardingOabContext,
  });
}

export function trackOnboardingOabStepViewed(): void {
  trackOnboardingOabEvent(
    EVENTS.ONBOARDING_OAB_STEP_VIEWED,
    false,
    '[Onboarding] Tela "Cadastre sua OAB" exibida ao usuário elegível, sem OAB já concluída.',
  );
}

export function trackOnboardingOabPendingFound(uf: string): void {
  trackOnboardingOabEvent(
    EVENTS.ONBOARDING_OAB_PENDING_FOUND,
    false,
    '[Onboarding] Tela "Cadastre sua OAB" abriu com uma OAB pendente encontrada e pré-preenchida.',
    { uf },
  );
}

export function trackOnboardingOabEdited(
  oabEditedField: OabEditedField,
): void {
  trackOnboardingOabEvent(
    EVENTS.ONBOARDING_OAB_EDITED,
    true,
    '[Onboarding] Usuário alterou pela primeira vez a OAB pendente pré-preenchida, indicando que o dado encontrado não o convenceu. Mede intenção de edição: dispara uma vez por visita e não desfaz se o usuário voltar ao valor original — o resultado final vai em oab_edited/oab_edited_fields de onboarding_oab_submitted.',
    { oab_edited_field: oabEditedField },
  );
}

export function trackOnboardingOabSubmitted(
  uf: string,
  oabNumberFilled: boolean,
  oabSource: OabSource,
  oabEdited: boolean,
  oabEditedFields: OabEditedFields,
): void {
  trackOnboardingOabEvent(
    EVENTS.ONBOARDING_OAB_SUBMITTED,
    true,
    '[Onboarding] Usuário clicou em "Confirmar OAB", tanto no cadastro manual quanto na confirmação de OAB pendente. oab_edited/oab_edited_fields medem o resultado no momento do submit: quem editou e voltou ao valor original aparece aqui como não editado, mesmo tendo disparado onboarding_oab_edited (que mede intenção).',
    {
      uf,
      oab_number_filled: oabNumberFilled,
      oab_source: oabSource,
      oab_edited: oabEdited,
      oab_edited_fields: oabEditedFields,
    },
  );
}

export function trackOnboardingOabSkipped(): void {
  trackOnboardingOabEvent(
    EVENTS.ONBOARDING_OAB_SKIPPED,
    true,
    '[Onboarding] Usuário clicou em "Ainda não tenho OAB", pulando a etapa.',
  );
}

export { EVENTS as ONBOARDING_OAB_EVENTS };
